import { createCommands } from 'utils/commands';

export const editorCopilotDropdownCommands = createCommands([
  {
    group: 'richTextEditor',
    label: 'Improve reply',
    name: 'improveReply',
    description: 'Opens the Improve reply modal',
  },
  {
    group: 'richTextEditor',
    label: 'Match to style guide',
    name: 'matchToStyleGuide',
    description:
      'Improves the selected text in the editor to match the applicable style guide',
  },
  {
    group: 'richTextEditor',
    label: "Translate selected text to conversation's language",
    name: 'translateToConversationLanguage',
    description:
      'Translates the selected text in the editor to the language of the conversation',
  },
  {
    group: 'richTextEditor',
    label: 'Translate selected text',
    name: 'translate',
    description: 'Translates the selected text in the editor',
  },
  {
    group: 'richTextEditor',
    label: 'Check spelling and grammar',
    name: 'checkSpellingAndGrammar',
    description:
      'Checks the spelling and grammar of selected text in the editor',
  },
]);
